import {
  Box,
  Button,
  FormControl,
  FormLabel,
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  NumberInput,
  NumberInputField,
  Select,
  SimpleGrid,
  Stack,
  Text,
  Textarea
} from "@chakra-ui/react";
import { SingleDatepicker } from "chakra-dayzed-datepicker";
import { GroupBase, Select as AutoComplete } from "chakra-react-select";
import { CentroCusto } from "models/centro_custo_type";
import { ClientClassificationType } from "models/client_classification_type";
import { CompraSericoTypeItem, CompraType, CompraTypeItem } from "models/compras_type";
import { CondicaoPagamento } from "models/condicao_pagamento_type";
import { ContaFinanceiro } from "models/conta_financeiro";
import { FinanceCategoryType } from "models/finance_category";
import { LancamentoFinanceiro } from "models/lancamento_type";
import { OrcamentoDepto } from "models/orcamento_departamento";
import { PessoaType } from "models/person_type";
import { ProductType } from "models/product_type";
import { OptionType } from "models/select_mode";
import { UsuarioModel } from "models/user_model";
import { MdAdd, MdEdit, MdMail, MdPrint, MdSave } from "react-icons/md";
import formatNumber from "views/admin/order/hooks/formatNumber";
import LancamentoTable from "../../contasReceber/components/LancamentoTable";
import ItemServicoTable from "./ItemServicoTable";
import ItemCompraTable from "./ItemTable";

interface IComprasForm {
  show: boolean;
  showModal: (show: boolean) => void;
  accountSelected: CompraType;
  categoria: FinanceCategoryType[];
  fornecedor: PessoaType[];
  condicaoPagamento: CondicaoPagamento[];
  showFormPessoa: (show: boolean) => void;
  editPessoa: (item: PessoaType) => void;
  save: () => void;
  selectedFornecedor: PessoaType;
  selectedCategoria: FinanceCategoryType;
  selectedCondicaoPagamentos: CondicaoPagamento;
  changeFornecedor: (item: string) => void;
  changeCategoria: (item: string) => void;
  changeCondicaoPagamento: (item: string) => void;
  changeDepto: (item: string) => void;
  changeCentroCusto: (item: string) => void;
  changeInput: (value: any, type: string) => void;
  textColor: string;
  brandStars: string;
  loading: boolean;
  changeUser: (item: string) => void;
  selectedUser: UsuarioModel;
  users: UsuarioModel[];
  itemList: CompraTypeItem[];
  borderColor: string;
  addRowItem: (item: CompraTypeItem) => void;
  deleteRow: (item: CompraTypeItem) => void;
  editRow: (item: CompraTypeItem) => void;
  dataCompra: Date;
  dataPrevista: Date;
  itemListFinanceiro: LancamentoFinanceiro[];
  addRowItemFinanceiro: (item: LancamentoFinanceiro) => void;
  editRowItemFinanceiro: (item: LancamentoFinanceiro) => void;
  deleteRowFinanceiro: (item: LancamentoFinanceiro) => void;
  user: UsuarioModel;
  generateParcela: (
    item: string,
    vencimento: Date,
    valor: number,
    fornecedor: string,
    tipoRecebimento: string
  ) => void;
  changeConta: (item: string) => void;
  contaFinanceiroLista: ContaFinanceiro[];
  selectedConta: ContaFinanceiro;
  selectedCentroCusto: CentroCusto;
  selectedDepto: ClientClassificationType;
  centroCusto: CentroCusto[];
  depto: ClientClassificationType[];
  changeDeptoOrcamento: (item: string) => void;
  selectedDeptoOrcamento: OrcamentoDepto;
  listDepto: OrcamentoDepto[];
  filiais: PessoaType[];
  onChangeFilial: (item: string) => void;
  selectedFilial: PessoaType;
  itemListServico: CompraSericoTypeItem[];
  addRowService: (item: CompraSericoTypeItem) => void;
  editRowService: (item: CompraSericoTypeItem) => void;
  deleteRowService: (item: CompraSericoTypeItem) => void;
  showError: (title: string, msg: string) => void;
  produtos: ProductType[];
}

const ComprasForm = ({
  accountSelected,
  brandStars,
  categoria,
  changeCategoria,
  changeCondicaoPagamento,
  changeFornecedor,
  changeInput,
  condicaoPagamento,
  editPessoa,
  fornecedor,
  loading,
  save,
  selectedCategoria,
  selectedCondicaoPagamentos,
  selectedFornecedor,
  show,
  showFormPessoa,
  showModal,
  textColor,
  changeUser,
  selectedUser,
  users,
  borderColor,
  itemList,
  addRowItem,
  deleteRow,
  editRow,
  dataCompra,
  dataPrevista,
  addRowItemFinanceiro,
  deleteRowFinanceiro,
  editRowItemFinanceiro,
  itemListFinanceiro,
  user,
  changeConta,
  changeDepto,
  changeCentroCusto,
  contaFinanceiroLista,
  generateParcela,
  selectedCentroCusto,
  selectedDepto,
  selectedConta,
  centroCusto,
  depto,
  changeDeptoOrcamento,
  listDepto,
  selectedDeptoOrcamento,
  filiais,
  onChangeFilial,
  selectedFilial,
  addRowService,
  deleteRowService,
  editRowService,
  itemListServico,
  produtos,
  showError
}: IComprasForm) => {
  return (
    <Box>
      <Box>
        <Box>
          <Box
            px="0px"
            mb="16px"
            mt="0px"
            justifyContent="space-between"
            ml={4}
          >
            <Stack direction="row" spacing={4}>
              <Button
                leftIcon={<MdMail />}
                colorScheme="brand"
                size={"sm"}
                variant="solid"
              >
                Enviar
              </Button>
              <Button
                leftIcon={<MdPrint />}
                colorScheme="brand"
                size={"sm"}
                variant="solid"
              >
                Imprimir
              </Button>
              <Button
                leftIcon={<MdSave />}
                colorScheme="brand"
                size={"sm"}
                variant="solid"
                isLoading={loading}
                onClick={() => save()}
              >
                Salvar
              </Button>
            </Stack>
          </Box>
        </Box>
        <SimpleGrid columns={3} spacing={4} mt={24}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Empresa Saída/Filial
            </FormLabel>

            <Select
              size="md"
              onChange={(e) => onChangeFilial(e.target.value)}
              defaultValue={accountSelected?.empresaSaiadaId}
            >
              <option value={"0"}>NENHUMA</option>
              {filiais?.map((item) => (
                <option value={item.id}>{item.nome}</option>
              ))}
            </Select>
          </FormControl>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
            >
              Fornecedor<Text color={brandStars}>*</Text>
            </FormLabel>
            <Box alignSelf={"flex-start"}>
              <Box w={"82%"}>
                <AutoComplete<OptionType, false, GroupBase<OptionType>>
                  size={"md"}
                  onChange={(e) => {
                    changeFornecedor(e.value);
                    if (
                      accountSelected?.valorPedido &&
                      dataCompra &&
                      selectedCondicaoPagamentos &&
                      accountSelected.tipoRecebimento
                    ) {
                      generateParcela(
                        selectedCondicaoPagamentos.id,
                        dataCompra,
                        accountSelected?.valorPedido,
                        e.value,
                        accountSelected.tipoRecebimento
                      );
                    }
                  }}
                  placeholder="Buscar..."
                  isDisabled={false}
                  name={"fornecedor"}
                  value={{
                    label: fornecedor?.find(
                      (f) => f.id === selectedFornecedor?.id
                    )?.nome,
                    value: selectedFornecedor?.id,
                  }}
                  options={fornecedor?.map((item) => {
                    return {
                      label: item?.nome,
                      value: item?.id,
                    };
                  })}
                />
              </Box>
              <IconButton
                colorScheme="brand"
                variant="solid"
                mt={-10}
                borderRadius={8}
                mr={12}
                size={"md"}
                icon={<MdAdd />}
                onClick={() => showFormPessoa(true)}
                float={"right"}
                aria-label={"Adicionar Cliente"}
              />
              <IconButton
                colorScheme="brand"
                variant="solid"
                size={"md"}
                mt={-10}
                ml={0}
                borderRadius={8}
                icon={<MdEdit />}
                onClick={() => {
                  editPessoa(selectedFornecedor);
                }}
                float={"right"}
                aria-label={"Editar Contato"}
              />
            </Box>
          </FormControl>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={"black"}
              mb="8px"
            >
              Usuário Responsável
            </FormLabel>

            <AutoComplete<OptionType, false, GroupBase<OptionType>>
              size="md"
              placeholder="Busque o Responsável"
              isRequired={true}
              name={"executivo"}
              onChange={(e) => {
                changeUser(e.value);
              }}
              options={users?.map((item) => {
                return {
                  label: item.nome,
                  value: item.id,
                };
              })}
              defaultValue={{
                label: selectedUser?.nome,
                value: selectedUser?.id,
              }}
            />
          </FormControl>
        </SimpleGrid>
        <SimpleGrid columns={5} spacing={4} mt={4}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
            >
              Planejamento Financeiro<Text color={brandStars}>*</Text>
            </FormLabel>
            <Box alignSelf={"flex-start"}>
              <AutoComplete<OptionType, false, GroupBase<OptionType>>
                size={"md"}
                onChange={(e) => changeDeptoOrcamento(e.value)}
                placeholder="Buscar..."
                isDisabled={false}
                name={"planoContas"}
                value={{
                  label: listDepto?.find(
                    (f) => f.id === selectedDeptoOrcamento?.id
                  )?.descricao,
                  value: selectedDeptoOrcamento?.id,
                }}
                options={listDepto?.map((item) => {
                  return {
                    label: item?.descricao,
                    value: item?.id,
                  };
                })}
              />
            </Box>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
            >
              Departamento<Text color={brandStars}>*</Text>
            </FormLabel>
            <Box alignSelf={"flex-start"}>
              <AutoComplete<OptionType, false, GroupBase<OptionType>>
                size={"md"}
                onChange={(e) => changeDepto(e.value)}
                placeholder="Buscar..."
                isDisabled={false}
                name={"fornecedor"}
                value={{
                  label: depto?.find((f) => f.id === selectedDepto?.id)?.nome,
                  value: selectedDepto?.id,
                }}
                options={depto?.map((item) => {
                  return {
                    label: item?.nome,
                    value: item?.id,
                  };
                })}
              />
            </Box>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
            >
              Centro de Custos<Text color={brandStars}>*</Text>
            </FormLabel>
            <Box alignSelf={"flex-start"}>
              <AutoComplete<OptionType, false, GroupBase<OptionType>>
                size={"md"}
                onChange={(e) => changeCentroCusto(e.value)}
                placeholder="Buscar..."
                isDisabled={false}
                name={"CentroCusto"}
                value={{
                  label: centroCusto?.find(
                    (f) => f.id === selectedCentroCusto?.id
                  )?.nome,
                  value: selectedCentroCusto?.id,
                }}
                options={centroCusto?.map((item) => {
                  return {
                    label: item?.nome,
                    value: item?.id,
                  };
                })}
              />
            </Box>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Origem
            </FormLabel>

            <Select
              size="md"
              onChange={(e) => changeInput(e.target.value, "origem")}
              defaultValue={accountSelected?.origem}
            >
              <option value={"0"}>SELECIONE A ORIGEM</option>
              <option value={"1"}>AVULSO</option>
              <option value={"2"}>PROJETO</option>
            </Select>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
            >
              Conta para Baixa<Text color={brandStars}>*</Text>
            </FormLabel>
            <Box alignSelf={"flex-start"}>
              <AutoComplete<OptionType, false, GroupBase<OptionType>>
                size={"md"}
                onChange={(e) => {
                  changeConta(e.value);
                }}
                placeholder="Buscar..."
                isDisabled={false}
                name={"contaFinanceiroLista"}
                defaultValue={{
                  label: contaFinanceiroLista?.find(
                    (f) => f.id === selectedConta?.id
                  )?.descricao,
                  value: selectedConta?.id,
                }}
                options={contaFinanceiroLista?.map((item) => {
                  return {
                    label: item?.descricao,
                    value: item?.id,
                  };
                })}
              />
            </Box>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
            >
              Forma de Pagamento<Text color={brandStars}>*</Text>
            </FormLabel>
            <Box alignSelf={"flex-start"}>
              <AutoComplete<OptionType, false, GroupBase<OptionType>>
                size={"md"}
                onChange={(e) => {
                  changeCondicaoPagamento(e.value);
                  if (accountSelected?.valorPedido > 0) {
                    generateParcela(
                      e.value,
                      dataCompra,
                      accountSelected?.valorPedido,
                      selectedFornecedor?.id,
                      accountSelected.tipoRecebimento
                    );
                  }
                }}
                placeholder="Buscar..."
                isDisabled={false}
                name={"condicaoPagamento"}
                value={{
                  label: condicaoPagamento?.find(
                    (f) => f.id === selectedCondicaoPagamentos?.id
                  )?.nome,
                  value: selectedCondicaoPagamentos?.id,
                }}
                options={condicaoPagamento?.map((item) => {
                  return {
                    label: item?.nome,
                    value: item?.id,
                  };
                })}
              />
            </Box>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Tipo de Pagamento
            </FormLabel>

            <Select
              size="md"
              onChange={(e) => {
                changeInput(e.target.value, "tipoRecebimento");
                generateParcela(
                  selectedCondicaoPagamentos.id,
                  dataCompra,
                  accountSelected?.valor,
                  selectedFornecedor?.id,
                  e.target.value
                );
              }}
              defaultValue={accountSelected?.tipoRecebimento}
            >
              <option value={"0"}>SELECIONE O TIPO DE PAGAMENTO</option>
              <option value={"1"}>BOLETO</option>
              <option value={"2"}>CHEQUE</option>
              <option value={"3"}>CARTÃO</option>
              <option value={"4"}>DINHEIRO</option>
              <option value={"5"}>DEPÓSITO</option>
              <option value={"6"}>DÉBITO EM CONTA</option>
              <option value={"7"}>FATURA</option>
              <option value={"8"}>ARRECADAÇÃO/RECEBIMENTO</option>
              <option value={"9"}>TRANSFÊRENCIA</option>
              <option value={"10"}>PIX</option>
            </Select>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
            >
              Categoria Financeira<Text color={brandStars}>*</Text>
            </FormLabel>
            <Box alignSelf={"flex-start"}>
              <AutoComplete<OptionType, false, GroupBase<OptionType>>
                size={"md"}
                onChange={(e) => changeCategoria(e.value)}
                placeholder="Buscar..."
                isDisabled={false}
                name={"categoria"}
                value={{
                  label: categoria?.find(
                    (f) => f.id === selectedCategoria?.id
                  )?.nome,
                  value: selectedCategoria?.id,
                }}
                options={categoria?.map((item) => {
                  return {
                    label: item?.nome,
                    value: item?.id,
                  };
                })}
              />
            </Box>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              color={textColor}
              mb="8px"
            >
              Data da Compra
            </FormLabel>
            <SingleDatepicker
              name="date-input-validade"
              configs={{
                dateFormat: "dd/MM/yyyy",
                dayNames: "DSTQQSS".split(""), // length of 7
                monthNames:
                  "JANEIRO FEVEREIRO MARÇO ABRIL MAIO JUNHO JULHO AGOSTO SETEMBRO OUTUBRO NOVEMBRO DEZEMBRO".split(
                    " "
                  ), // length of 12
                firstDayOfWeek: 0,
                // default is 0, the dayNames[0], which is Sunday if you don't specify your own dayNames,
              }}
              propsConfigs={{
                dayOfMonthBtnProps: {
                  selectedBtnProps: {
                    background: "#422afb",
                    color: "white",
                  },
                },
              }}
              date={dataCompra}
              onDateChange={(date: any) => {
                changeInput(date, "dataCompra");

                if (
                  selectedCondicaoPagamentos &&
                  accountSelected?.valor &&
                  selectedFornecedor &&
                  accountSelected.tipoRecebimento
                ) {
                  generateParcela(
                    selectedCondicaoPagamentos.id,
                    date,
                    accountSelected?.valor,
                    selectedFornecedor?.id,
                    accountSelected.tipoRecebimento
                  );
                }
              }}
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              color={textColor}
              mb="8px"
            >
              Data Prevista
            </FormLabel>
            <SingleDatepicker
              name="date-input-validade"
              configs={{
                dateFormat: "dd/MM/yyyy",
                dayNames: "DSTQQSS".split(""), // length of 7
                monthNames:
                  "JANEIRO FEVEREIRO MARÇO ABRIL MAIO JUNHO JULHO AGOSTO SETEMBRO OUTUBRO NOVEMBRO DEZEMBRO".split(
                    " "
                  ), // length of 12
                firstDayOfWeek: 0,
                // default is 0, the dayNames[0], which is Sunday if you don't specify your own dayNames,
              }}
              propsConfigs={{
                dayOfMonthBtnProps: {
                  selectedBtnProps: {
                    background: "#422afb",
                    color: "white",
                  },
                },
              }}
              date={dataPrevista}
              onDateChange={(date: any) => {
                changeInput(date, "dataPrevista");
              }}
            />
          </FormControl>
        </SimpleGrid>

        <Text
          mt={8}
          fontSize={18}
          color={"#422AFB"}
          fontWeight={"bold"}
          mb={4}
        >
          Serviços do Pedido
        </Text>

        <ItemServicoTable
          addRowService={addRowService}
          borderColor={borderColor}
          condicaoPagamento={condicaoPagamento}
          deleteRowService={deleteRowService}
          editRowService={editRowService}
          itemList={itemListServico}
          produtos={produtos}
          showError={showError}
        />


        <Text
          mt={8}
          fontSize={18}
          color={"#422AFB"}
          fontWeight={"bold"}
          mb={4}
        >
          Produtos do Pedido
        </Text>
        <ItemCompraTable
          borderColor={borderColor}
          itemList={itemList}
          addRowItem={addRowItem}
          deleteRow={deleteRow}
          editRow={editRow}
        />



        <SimpleGrid columns={8} spacing={4} mt={18}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Total dos Produtos
            </FormLabel>
            <NumberInput
              min={0}
              isDisabled={true}
              value={
                isNaN(accountSelected?.valor)
                  ? formatNumber(0)
                  : formatNumber(Number(accountSelected?.valor))
              }
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Total ICMS ST
            </FormLabel>
            <NumberInput
              min={0}
              precision={2}
              defaultValue={accountSelected?.icms}
              onChange={(e: string) => {
                changeInput(e, "icms");
              }}
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Total IPI
            </FormLabel>
            <NumberInput
              min={0}
              isDisabled={true}
              value={
                isNaN(accountSelected?.ipi)
                  ? formatNumber(0)
                  : formatNumber(Number(accountSelected?.ipi))
              }
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Total Pedido
            </FormLabel>
            <NumberInput
              min={0}
              precision={2}
              isDisabled={true}
              value={
                isNaN(accountSelected?.valorPedido)
                  ? formatNumber(0)
                  : formatNumber(Number(accountSelected?.valorPedido))
              }
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Quantidade de itens
            </FormLabel>
            <NumberInput min={0} isDisabled={true} value={itemList?.length}>
              <NumberInputField />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Número de Itens
            </FormLabel>
            <NumberInput
              min={0}
              isDisabled={true}
              value={itemList?.reduce(
                (acc, item) => acc + Number(item.quantidade),
                0
              )}
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Desconto
            </FormLabel>
            <NumberInput
              min={0}
              precision={2}
              defaultValue={accountSelected?.desconto}
              onChange={(e: string) => {
                changeInput(e, "desconto");
              }}
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Frete
            </FormLabel>
            <NumberInput
              min={0}
              precision={2}
              defaultValue={accountSelected?.frete}
              onChange={(e: string) => {
                changeInput(e, "frete");
              }}
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>
        </SimpleGrid>
        <Text
          mt={8}
          fontSize={18}
          color={"#422AFB"}
          fontWeight={"bold"}
          mb={4}
        >
          Lançamentos -{" "}
          {formatNumber(
            itemListFinanceiro.reduce(
              (value, acc) => Number(acc.valor) + value,
              0
            )
          )}
        </Text>
        <LancamentoTable
          itemList={itemListFinanceiro}
          addRowItem={addRowItemFinanceiro}
          editRowItem={editRowItemFinanceiro}
          deleteRow={deleteRowFinanceiro}
          borderColor={borderColor}
          textColor={textColor}
          selectedCliente={selectedFornecedor}
          user={user}
          tipo={false}
        />

        <SimpleGrid spacing={4}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mt={4}
              color={textColor}
            >
              Dados Adicionais<Text color={brandStars}>*</Text>
            </FormLabel>
            <Textarea
              defaultValue={accountSelected?.observacao}
              fontSize="sm"
              height={100}
              ms={{ base: "0px", md: "0px" }}
              placeholder="Preencha os Dados Adicionais"
              onChange={(e) => {
                changeInput(e.target.value, "observacao");
              }}
              fontWeight="500"
              size="md"
            />
          </FormControl>
        </SimpleGrid>
      </Box>
    </Box>
  );
};
export default ComprasForm;
